import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryLookBookTopics(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-topics`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryLookBookTopic(lookBookTopicId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-topics/${lookBookTopicId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @param  coverPath
 * @param  topImagePath
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addLookBookTopic(
  {
    name,
    coverPath,
    subName,
    nameEn,
    description,
    descriptionEn,
    recommendName,
    recommendNameEn,
    recommendSubName,
    recommendSubNameEn,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-topics`,
    method: 'post',
    data: {
      name,
      coverPath,
      subName,
      nameEn,
      description,
      descriptionEn,
      recommendName,
      recommendNameEn,
      recommendSubName,
      recommendSubNameEn,
    },
  });
}

/**
 * 更新
 * @param lookBookTopicId
 * @param  name
 * @param  coverPath
 * @param  topImagePath
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateLookBookTopic(lookBookTopicId, {
  name,
  coverPath,
  subName,
  nameEn,
  description,
  descriptionEn,
  recommendName,
  recommendNameEn,
  recommendSubName,
  recommendSubNameEn,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-topics/${lookBookTopicId}`,
    method: 'patch',
    data: {
      name,
      coverPath,
      subName,
      nameEn,
      description,
      descriptionEn,
      recommendName,
      recommendNameEn,
      recommendSubName,
      recommendSubNameEn,
    },
  });
}

/**
 * 删除
 * @param lookBookTopicId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteLookBookTopic(lookBookTopicId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-topics/${lookBookTopicId}`,
    method: 'delete',
  });
}

/**
 * 删除
 * @param lookBookTopicId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upLookBookTopic(lookBookTopicId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-topics/${lookBookTopicId}/up`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param lookBookTopicId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downLookBookTopic(lookBookTopicId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-topics/${lookBookTopicId}/down`,
    method: 'patch',
  });
}

export default {};
